import { AuthHttpClient } from './authHttpClient.service';
import { LoggerService } from '../logger/logger.service';
import { HttpHandler, HttpClient } from '@angular/common/http';

export function httpClientFactory(logger: LoggerService, httpHandler: HttpHandler): HttpClient {
  return new AuthHttpClient(logger, httpHandler);
}
